enum RoomDetailItemTypeEnum {
    isBoolean = "isBoolean",
    isTextArea = "isTextArea",
    isAddress = "isAddress",
    isDate = "isDate",
    isNumber = "isNumber",
    isSelectOption = "isSelectOption",
    categoryViewOnly = "categoryViewOnly",
    staticText = "staticText",
}

export default RoomDetailItemTypeEnum;
